module.exports = __webpack_public_path__ + "static/media/cross.abb8a771.svg";